const formatPageData = props => {
  if (!props.data) return

  const data = {}

  Object.entries(props.data).forEach(([key,prop]) => {
    if (prop.content) {
      data[key] = JSON.parse(prop.content)
    }

    if (prop.nodes) {
      data[key] = []

      prop.nodes.forEach(node => {
        data[key].push(JSON.parse(node.content))
      })
    }
  })

  data.context = props.pageContext

  return data
}

export default formatPageData 